// Shared Reverb connection settings for both Echo boots.
// Host resolution: dev environments inject VITE_REVERB_* (standard Laravel
// Reverb naming), production CI ships legacy MIX_PUSHER_* via .env.ci, and
// with neither set we target the app's own host — Reverb is fronted by the
// same ingress as the app.
export const echoConnectionOptions = () => {
  const port = Number(process.env.VITE_REVERB_PORT || process.env.MIX_PUSHER_PORT || 443)
  return {
    broadcaster: 'pusher' as const,
    key: process.env.VITE_REVERB_APP_KEY || process.env.MIX_PUSHER_APP_KEY,
    wsHost: process.env.VITE_REVERB_HOST || process.env.MIX_PUSHER_HOST || window.location.hostname,
    wsPort: port,
    wssPort: port,
    cluster: 'mt1',
    forceTLS: (process.env.VITE_REVERB_SCHEME || 'https') === 'https',
    encrypted: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
  }
}
